import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { TablePdf } from "../TablePdf/TablePdf";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { DataTableCell } from "@david.kucsai/react-pdf-table";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewPaymentCosts(props) {
  let totalCount = 0;
  let totalAmount = 0;

  let data = Object.keys(props.paymentCosts).map((paymentMethod) => {
    totalCount += props.paymentCosts[paymentMethod].count;
    totalAmount += props.paymentCosts[paymentMethod].amount;
    return {
      paymentMethod: paymentMethod,
      count: props.paymentCosts[paymentMethod].count,
      amount: GetCurrency() + (props.paymentCosts[paymentMethod].amount / 100.0).toFixed(2),
    };
  });

  const getPdfView = () => {
    return (
      <TablePdf data={data}>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Betaalkosten</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Aantal
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Bedrag
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <DataTableCell weighting={0.3} getContent={(r) => r.paymentMethod} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.count} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.amount} />
        </TableBodyPDF>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {totalCount}
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {GetCurrency() + (totalAmount / 100.0).toFixed(2)}
          </TableCellPDF>
        </TableHeaderPDF>
      </TablePdf>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Betaalkosten</TableCell>
            <TableCell align={"right"}>Aantal</TableCell>
            <TableCell align={"right"}>Bedrag</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((r) => {
            return (
              <TableRow key={r.paymentMethod}>
                <TableCell>{r.paymentMethod}</TableCell>
                <TableCell align={"right"}>{r.count}</TableCell>
                <TableCell align={"right"}>{r.amount}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align={"right"}>{totalCount}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(totalAmount / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
